// src/utils/services/AdvancedMD/followUpExam20.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const FOLLOW_UP_EXAM20_URL = `${API_BASE_URL}/api/advancedmd/followup-exam-20`;

/**
 * Obtiene las notas "Follow Up Exam 2.0" de un paciente.
 * Devuelve la lista de AmdFollowUpExam20Dto / AmdClinicalNoteDto.
 */
export async function getFollowUpExam20Notes(patientId) {
  try {
    const url = `${FOLLOW_UP_EXAM20_URL}/${encodeURIComponent(patientId)}`;
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.error("Error getFollowUpExam20Notes:", err);
    throw err;
  }
}
